<template>
    <div class="row-v-table">
        <v-row no-gutters>
            <v-col cols="12" md="6">
                <counsel-card-row label="작성업체" :cols="12" :md="4">{{ request.requester.companyName }}</counsel-card-row>
            </v-col>
            <v-col cols="12" md="6">
                <counsel-card-row label="자문요청일" :cols="12" :md="4">{{ request.createdAt.toDateTime() }}</counsel-card-row>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" md="6">
                <view-area :area="request.area" />
            </v-col>
            <v-col cols="12" md="6">
                <view-duration v-if="isLong" :request="request" />
                <counsel-card-row v-else label="상태" :cols="12" :md="4">{{ request.status }}</counsel-card-row>
            </v-col>
        </v-row>
        <counsel-card-row label="제목">{{ request.title }}</counsel-card-row>
        <counsel-card-row label="상세내용">{{ request.content }}</counsel-card-row>
        <view-files :files="request.files" />
    </div>
</template>

<script>
import CounselCard from "./counsel-card.vue";
import CounselCardRow from "./counsel-card-row.vue";
import ViewArea from './view-request-area.vue';
import ViewDuration from './view-request-duration.vue';
import ViewFiles from './view-request-files.vue';
export default {
    components: { CounselCard, CounselCardRow, ViewArea, ViewDuration, ViewFiles },
    props: ["request", "isLong"],
};
</script>

<style></style>
